export const getDay = (dayString) => {
  switch (dayString) {
    case 'M':
      return 'Monday'
    case 'T':
      return 'Tuesday'
    case 'W':
      return 'Wednesday'
    case 'TH':
      return 'Thursday'
    case 'F':
      return 'Friday'
    case 'SA':
      return 'Saturday'
    case 'SU':
      return 'Sunday'
    default:
      return null
  }
}


// WEBPACK FOOTER //
// ./src/lib/helpers.js